import d, { useState as te, useCallback as Xe, useEffect as Y, useRef as fe } from "react";
import { clsx as Ze } from "clsx";
const Qe = {
  xxs: "vd-text-icon-16",
  xs: "vd-text-icon-20",
  sm: "vd-text-icon-24",
  md: "vd-text-icon-32",
  lg: "vd-text-icon-40",
  xl: "vd-text-icon-56"
}, Ye = {
  "icon-accent-secondary-medium": "vd-text-icon-accent-secondary-soft",
  "icon-accent-secondary-soft": "vd-text-icon-accent-secondary-soft",
  "icon-accent-secondary-strong": "vd-text-icon-accent-secondary-strong",
  "icon-accent-v1-medium": "vd-text-icon-accent-v1-medium",
  "icon-accent-v1-soft": "vd-text-icon-accent-v1-soft",
  "icon-accent-v1-strong": "vd-text-icon-accent-v1-strong",
  "icon-accent-v2-medium": "vd-text-icon-accent-v2-medium",
  "icon-accent-v2-soft": "vd-text-icon-accent-v2-soft",
  "icon-accent-v2-strong": "vd-text-icon-accent-v2-strong",
  "icon-accent-v3-medium": "vd-text-icon-accent-v3-medium",
  "icon-accent-v3-soft": "vd-text-icon-accent-v3-soft",
  "icon-accent-v3-strong": "vd-text-icon-accent-v3-strong",
  "icon-alert-caution-medium": "vd-text-icon-alert-caution-medium",
  "icon-alert-caution-soft": "vd-text-icon-alert-caution-soft",
  "icon-alert-caution-strong": "vd-text-icon-alert-caution-strong",
  "icon-alert-danger-medium": "vd-text-icon-alert-danger-medium",
  "icon-alert-danger-soft": "vd-text-icon-alert-danger-soft",
  "icon-alert-danger-strong": "vd-text-icon-alert-danger-strong",
  "icon-alert-success-medium": "vd-text-icon-alert-success-medium",
  "icon-alert-success-soft": "vd-text-icon-alert-success-soft",
  "icon-alert-success-strong": "vd-text-icon-alert-success-strong",
  "icon-brand-medium": "vd-text-icon-brand-medium",
  "icon-brand-soft": "vd-text-icon-brand-soft",
  "icon-brand-strong": "vd-text-icon-brand-strong",
  "icon-neutral-disabled": "vd-text-icon-neutral-disabled",
  "icon-neutral-inverse-disabled": "vd-text-icon-neutral-inverse-disabled",
  "icon-neutral-medium": "vd-text-icon-neutral-medium",
  "icon-neutral-soft": "vd-text-icon-neutral-soft",
  "icon-neutral-strong": "vd-icon-neutral-strong",
  "icon-neutral-inverse-medium": "vd-text-icon-neutral-inverse-medium",
  "icon-neutral-inverse-soft": "vd-text-icon-neutral-inverse-soft",
  "icon-neutral-inverse-strong": "vd-text-icon-neutral-inverse-strong"
}, ie = "-";
function et(e) {
  const r = rt(e), {
    conflictingClassGroups: t,
    conflictingClassGroupModifiers: o
  } = e;
  function s(l) {
    const a = l.split(ie);
    return a[0] === "" && a.length !== 1 && a.shift(), Ie(a, r) || tt(l);
  }
  function n(l, a) {
    const v = t[l] || [];
    return a && o[l] ? [...v, ...o[l]] : v;
  }
  return {
    getClassGroupId: s,
    getConflictingClassGroupIds: n
  };
}
function Ie(e, r) {
  var l;
  if (e.length === 0)
    return r.classGroupId;
  const t = e[0], o = r.nextPart.get(t), s = o ? Ie(e.slice(1), o) : void 0;
  if (s)
    return s;
  if (r.validators.length === 0)
    return;
  const n = e.join(ie);
  return (l = r.validators.find(({
    validator: a
  }) => a(n))) == null ? void 0 : l.classGroupId;
}
const ge = /^\[(.+)\]$/;
function tt(e) {
  if (ge.test(e)) {
    const r = ge.exec(e)[1], t = r == null ? void 0 : r.substring(0, r.indexOf(":"));
    if (t)
      return "arbitrary.." + t;
  }
}
function rt(e) {
  const {
    theme: r,
    prefix: t
  } = e, o = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return dt(Object.entries(e.classGroups), t).forEach(([n, l]) => {
    ne(l, o, n, r);
  }), o;
}
function ne(e, r, t, o) {
  e.forEach((s) => {
    if (typeof s == "string") {
      const n = s === "" ? r : me(r, s);
      n.classGroupId = t;
      return;
    }
    if (typeof s == "function") {
      if (ot(s)) {
        ne(s(o), r, t, o);
        return;
      }
      r.validators.push({
        validator: s,
        classGroupId: t
      });
      return;
    }
    Object.entries(s).forEach(([n, l]) => {
      ne(l, me(r, n), t, o);
    });
  });
}
function me(e, r) {
  let t = e;
  return r.split(ie).forEach((o) => {
    t.nextPart.has(o) || t.nextPart.set(o, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), t = t.nextPart.get(o);
  }), t;
}
function ot(e) {
  return e.isThemeGetter;
}
function dt(e, r) {
  return r ? e.map(([t, o]) => {
    const s = o.map((n) => typeof n == "string" ? r + n : typeof n == "object" ? Object.fromEntries(Object.entries(n).map(([l, a]) => [r + l, a])) : n);
    return [t, s];
  }) : e;
}
function nt(e) {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let r = 0, t = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map();
  function s(n, l) {
    t.set(n, l), r++, r > e && (r = 0, o = t, t = /* @__PURE__ */ new Map());
  }
  return {
    get(n) {
      let l = t.get(n);
      if (l !== void 0)
        return l;
      if ((l = o.get(n)) !== void 0)
        return s(n, l), l;
    },
    set(n, l) {
      t.has(n) ? t.set(n, l) : s(n, l);
    }
  };
}
const ze = "!";
function st(e) {
  const r = e.separator, t = r.length === 1, o = r[0], s = r.length;
  return function(l) {
    const a = [];
    let v = 0, i = 0, c;
    for (let g = 0; g < l.length; g++) {
      let m = l[g];
      if (v === 0) {
        if (m === o && (t || l.slice(g, g + s) === r)) {
          a.push(l.slice(i, g)), i = g + s;
          continue;
        }
        if (m === "/") {
          c = g;
          continue;
        }
      }
      m === "[" ? v++ : m === "]" && v--;
    }
    const h = a.length === 0 ? l : l.substring(i), E = h.startsWith(ze), f = E ? h.substring(1) : h, N = c && c > i ? c - i : void 0;
    return {
      modifiers: a,
      hasImportantModifier: E,
      baseClassName: f,
      maybePostfixModifierPosition: N
    };
  };
}
function lt(e) {
  if (e.length <= 1)
    return e;
  const r = [];
  let t = [];
  return e.forEach((o) => {
    o[0] === "[" ? (r.push(...t.sort(), o), t = []) : t.push(o);
  }), r.push(...t.sort()), r;
}
function at(e) {
  return {
    cache: nt(e.cacheSize),
    splitModifiers: st(e),
    ...et(e)
  };
}
const ct = /\s+/;
function it(e, r) {
  const {
    splitModifiers: t,
    getClassGroupId: o,
    getConflictingClassGroupIds: s
  } = r, n = /* @__PURE__ */ new Set();
  return e.trim().split(ct).map((l) => {
    const {
      modifiers: a,
      hasImportantModifier: v,
      baseClassName: i,
      maybePostfixModifierPosition: c
    } = t(l);
    let h = o(c ? i.substring(0, c) : i), E = !!c;
    if (!h) {
      if (!c)
        return {
          isTailwindClass: !1,
          originalClassName: l
        };
      if (h = o(i), !h)
        return {
          isTailwindClass: !1,
          originalClassName: l
        };
      E = !1;
    }
    const f = lt(a).join(":");
    return {
      isTailwindClass: !0,
      modifierId: v ? f + ze : f,
      classGroupId: h,
      originalClassName: l,
      hasPostfixModifier: E
    };
  }).reverse().filter((l) => {
    if (!l.isTailwindClass)
      return !0;
    const {
      modifierId: a,
      classGroupId: v,
      hasPostfixModifier: i
    } = l, c = a + v;
    return n.has(c) ? !1 : (n.add(c), s(v, i).forEach((h) => n.add(a + h)), !0);
  }).reverse().map((l) => l.originalClassName).join(" ");
}
function ut() {
  let e = 0, r, t, o = "";
  for (; e < arguments.length; )
    (r = arguments[e++]) && (t = Te(r)) && (o && (o += " "), o += t);
  return o;
}
function Te(e) {
  if (typeof e == "string")
    return e;
  let r, t = "";
  for (let o = 0; o < e.length; o++)
    e[o] && (r = Te(e[o])) && (t && (t += " "), t += r);
  return t;
}
function pe(e, ...r) {
  let t, o, s, n = l;
  function l(v) {
    const i = r.reduce((c, h) => h(c), e());
    return t = at(i), o = t.cache.get, s = t.cache.set, n = a, a(v);
  }
  function a(v) {
    const i = o(v);
    if (i)
      return i;
    const c = it(v, t);
    return s(v, c), c;
  }
  return function() {
    return n(ut.apply(null, arguments));
  };
}
function w(e) {
  const r = (t) => t[e] || [];
  return r.isThemeGetter = !0, r;
}
const Me = /^\[(?:([a-z-]+):)?(.+)\]$/i, vt = /^\d+\/\d+$/, bt = /* @__PURE__ */ new Set(["px", "full", "screen"]), xt = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, ft = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, gt = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, mt = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, pt = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
function P(e) {
  return W(e) || bt.has(e) || vt.test(e);
}
function R(e) {
  return H(e, "length", Ct);
}
function W(e) {
  return !!e && !Number.isNaN(Number(e));
}
function Q(e) {
  return H(e, "number", W);
}
function D(e) {
  return !!e && Number.isInteger(Number(e));
}
function ht(e) {
  return e.endsWith("%") && W(e.slice(0, -1));
}
function x(e) {
  return Me.test(e);
}
function G(e) {
  return xt.test(e);
}
const yt = /* @__PURE__ */ new Set(["length", "size", "percentage"]);
function wt(e) {
  return H(e, yt, Ae);
}
function kt(e) {
  return H(e, "position", Ae);
}
const Et = /* @__PURE__ */ new Set(["image", "url"]);
function Nt(e) {
  return H(e, Et, It);
}
function St(e) {
  return H(e, "", $t);
}
function J() {
  return !0;
}
function H(e, r, t) {
  const o = Me.exec(e);
  return o ? o[1] ? typeof r == "string" ? o[1] === r : r.has(o[1]) : t(o[2]) : !1;
}
function Ct(e) {
  return ft.test(e) && !gt.test(e);
}
function Ae() {
  return !1;
}
function $t(e) {
  return mt.test(e);
}
function It(e) {
  return pt.test(e);
}
function he() {
  const e = w("colors"), r = w("spacing"), t = w("blur"), o = w("brightness"), s = w("borderColor"), n = w("borderRadius"), l = w("borderSpacing"), a = w("borderWidth"), v = w("contrast"), i = w("grayscale"), c = w("hueRotate"), h = w("invert"), E = w("gap"), f = w("gradientColorStops"), N = w("gradientColorStopPositions"), g = w("inset"), m = w("margin"), p = w("opacity"), S = w("padding"), z = w("saturate"), $ = w("scale"), M = w("sepia"), B = w("skew"), L = w("space"), y = w("translate"), j = () => ["auto", "contain", "none"], A = () => ["auto", "hidden", "clip", "visible", "scroll"], _ = () => ["auto", x, r], k = () => [x, r], ue = () => ["", P, R], K = () => ["auto", W, x], ve = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], X = () => ["solid", "dashed", "dotted", "double", "none"], be = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], oe = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], q = () => ["", "0", x], xe = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], U = () => [W, Q], Z = () => [W, x];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [J],
      spacing: [P, R],
      blur: ["none", "", G, x],
      brightness: U(),
      borderColor: [e],
      borderRadius: ["none", "", "full", G, x],
      borderSpacing: k(),
      borderWidth: ue(),
      contrast: U(),
      grayscale: q(),
      hueRotate: Z(),
      invert: q(),
      gap: k(),
      gradientColorStops: [e],
      gradientColorStopPositions: [ht, R],
      inset: _(),
      margin: _(),
      opacity: U(),
      padding: k(),
      saturate: U(),
      scale: U(),
      sepia: q(),
      skew: Z(),
      space: k(),
      translate: k()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", x]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [G]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": xe()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": xe()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...ve(), x]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: A()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": A()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": A()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: j()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": j()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": j()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [g]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [g]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [g]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [g]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [g]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [g]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [g]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [g]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [g]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", D, x]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: _()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", x]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: q()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: q()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", D, x]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [J]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", D, x]
        }, x]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": K()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": K()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [J]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [D, x]
        }, x]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": K()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": K()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", x]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", x]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [E]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [E]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [E]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...oe()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...oe(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...oe(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [S]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [S]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [S]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [S]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [S]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [S]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [S]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [S]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [S]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [m]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [m]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [m]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [m]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [m]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [m]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [m]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [m]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [m]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [L]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [L]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", x, r]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [x, r, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [x, r, "none", "full", "min", "max", "fit", "prose", {
          screen: [G]
        }, G]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [x, r, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [x, r, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [x, r, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [x, r, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", G, R]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", Q]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [J]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", x]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", W, Q]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", P, x]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", x]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", x]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [p]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [p]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...X(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", P, R]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", P, x]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: k()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", x]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", x]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [p]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...ve(), kt]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", wt]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, Nt]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [N]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [N]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [N]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [f]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [f]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [f]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [n]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [n]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [n]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [n]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [n]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [n]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [n]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [n]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [n]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [n]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [n]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [n]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [n]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [n]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [n]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [a]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [a]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [a]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [a]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [a]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [a]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [a]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [a]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [a]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [p]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...X(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [a]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [a]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [p]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: X()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [s]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [s]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [s]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [s]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [s]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [s]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [s]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [s]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...X()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [P, x]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [P, R]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: ue()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [p]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [P, R]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", G, St]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [J]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [p]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...be(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": be()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [t]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [o]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [v]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", G, x]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [i]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [c]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [h]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [z]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [M]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [t]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [o]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [v]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [i]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [c]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [h]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [p]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [z]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [M]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [l]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [l]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [l]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", x]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: Z()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", x]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: Z()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", x]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [$]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [$]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [$]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [D, x]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [y]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [y]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [B]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [B]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", x]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", x]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": k()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": k()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": k()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": k()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": k()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": k()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": k()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": k()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": k()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": k()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": k()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": k()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": k()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": k()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": k()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": k()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": k()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": k()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", x]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [P, R, Q]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
function zt(e, {
  cacheSize: r,
  prefix: t,
  separator: o,
  extend: s = {},
  override: n = {}
}) {
  ee(e, "cacheSize", r), ee(e, "prefix", t), ee(e, "separator", o);
  for (const l in n)
    Tt(e[l], n[l]);
  for (const l in s)
    Mt(e[l], s[l]);
  return e;
}
function ee(e, r, t) {
  t !== void 0 && (e[r] = t);
}
function Tt(e, r) {
  if (r)
    for (const t in r)
      ee(e, t, r[t]);
}
function Mt(e, r) {
  if (r)
    for (const t in r) {
      const o = r[t];
      o !== void 0 && (e[t] = (e[t] || []).concat(o));
    }
}
function At(e, ...r) {
  return typeof e == "function" ? pe(he, e, ...r) : pe(() => zt(he(), e), ...r);
}
const Pt = At({
  extend: {
    classGroups: {
      "font-size": [
        {
          text: [
            "vd-icon-16",
            "vd-icon-20",
            "vd-icon-24",
            "vd-icon-28",
            "vd-icon-32",
            "vd-icon-40",
            "vd-icon-56",
            "MD1",
            "MD2",
            "MD3",
            "MT1",
            "MT2",
            "MT3",
            "MH1",
            "MH2",
            "MH3",
            "MB1",
            "MB2",
            "MB3",
            "Mcaption",
            "btn-brand-text-text-rest"
          ]
        }
      ]
    }
  }
});
function u(...e) {
  return Pt(Ze(e.filter(Boolean).join(" ")));
}
const C = ({
  name: e,
  iconSize: r = "xs",
  color: t = null,
  type: o = "line",
  className: s = ""
}) => e ? /* @__PURE__ */ d.createElement(d.Fragment, null, /* @__PURE__ */ d.createElement(
  "i",
  {
    className: u(
      `${o}-${e}  ${Qe[r]} ${Ye[t]} ${s}`
    )
  }
)) : null;
var F = /* @__PURE__ */ ((e) => (e.d1 = "vd-text-MD1 sm:vd-text-D1", e.d2 = "vd-text-MD2 sm:vd-text-D2 ", e.d3 = "sm:vd-text-D3 vd-text-MD3", e.t1 = "sm:vd-text-T1 vd-text-M1", e.t2 = "sm:vd-text-T2 vd-text-M2", e.t3 = "sm:vd-text-T3 vd-text-M3", e.h1 = "sm:vd-text-H1 vd-text-MH1", e.h2 = "sm:vd-text-H2 vd-text-MH2", e.h3 = "sm:vd-text-H3 vd-text-MH3", e.b1 = "sm:vd-text-B1 vd-text-MB1", e.b2 = "sm:vd-text-B2 vd-text-MB2", e.b3 = "sm:vd-text-B3 vd-text-MB3", e.caption = "sm:vd-text-caption vd-text-Mcaption", e))(F || {}), Pe = /* @__PURE__ */ ((e) => (e.extrabold = "vd-font-extrabold", e.semibold = "vd-font-semibold", e.bold = "vd-font-bold", e.regular = "vd-font-normal", e.light = "vd-font-light", e))(Pe || {}), Re = /* @__PURE__ */ ((e) => (e.roman = "vd-not-italic", e.italic = "vd-italic", e))(Re || {}), O = /* @__PURE__ */ ((e) => (e.d1 = "vd-tracking-d1", e.d2 = "vd-tracking-d2", e.d3 = "vd-tracking-d3", e.t1 = "vd-tracking-t1", e.t2 = "vd-tracking-t2", e.t3 = "vd-tracking-t3", e.h1 = "vd-tracking-h1", e.h2 = "vd-tracking-h2", e.h3 = "vd-tracking-h3", e.b1 = "vd-tracking-b1", e.b2 = "vd-tracking-b2", e.b3 = "vd-tracking-b3", e.caption = "vd-tracking-caption", e))(O || {}), Ge = /* @__PURE__ */ ((e) => (e.sans = "vd-font-sans", e.caveat = "vd-font-caveat", e))(Ge || {}), Be = /* @__PURE__ */ ((e) => (e["text-accent-secondary-medium"] = "vd-text-text-accent-secondary-medium", e["text-accent-secondary-soft"] = "vd-text-text-accent-secondary-soft", e["text-accent-secondary-strong"] = "vd-text-text-accent-secondary-strong", e["text-accent-v1-medium"] = "vd-text-text-accent-v1-medium", e["text-accent-v1-soft"] = "vd-text-text-accent-v1-soft", e["text-accent-v1-strong"] = "vd-text-text-accent-v1-strong", e["text-accent-v2-medium"] = "vd-text-text-accent-v2-medium", e["text-accent-v2-soft"] = "vd-text-text-accent-v2-soft", e["text-accent-v2-strong"] = "vd-text-text-accent-v2-strong", e["text-accent-v3-medium"] = "vd-text-text-accent-v3-medium", e["text-accent-v3-soft"] = "vd-text-text-accent-v3-soft", e["text-accent-v3-strong"] = "vd-text-text-accent-v3-strong", e["text-alert-discovery"] = "vd-text-text-alert-discovery", e["text-alert-information"] = "vd-text-text-alert-information", e["text-alert-selection"] = "vd-text-text-alert-selection", e["text-alert-caution-inverse"] = "vd-text-text-alert-caution-inverse", e["text-alert-caution-medium"] = "vd-text-text-alert-caution-medium", e["text-alert-caution-soft"] = "vd-text-text-alert-caution-soft", e["text-alert-caution-strong"] = "vd-text-text-alert-caution-strong", e["text-alert-danger-medium"] = "vd-text-text-alert-danger-medium", e["text-alert-danger-soft"] = "vd-text-text-alert-danger-soft", e["text-alert-danger-strong"] = "vd-text-text-alert-danger-strong", e["text-alert-success-medium"] = "vd-text-text-alert-success-medium", e["text-alert-success-soft"] = "vd-text-text-alert-success-soft", e["text-alert-success-strong"] = "vd-text-text-alert-success-strong", e["text-brand-medium"] = "vd-text-text-brand-medium", e["text-brand-soft"] = "vd-text-text-brand-soft", e["text-brand-strong"] = "vd-text-text-brand-strong", e["text-neutral-disabled"] = "vd-text-text-neutral-disabled", e["text-neutral-primary"] = "vd-text-text-neutral-primary", e["text-neutral-secondary"] = "vd-text-text-neutral-secondary", e["text-neutral-tertiary"] = "vd-text-text-neutral-tertiary", e["text-neutral-inverse-disabled"] = "vd-text-text-neutral-inverse-disabled", e["text-neutral-inverse-primary"] = "vd-text-text-neutral-inverse-primary", e["text-neutral-inverse-secondary"] = "vd-text-text-neutral-inverse-secondary", e["text-neutral-inverse-tertiary"] = "vd-text-text-neutral-inverse-tertiary", e))(Be || {});
const Rt = {
  brand: "group vd-p-0 vd-font-semibold vd-border-0",
  neutral: "group vd-p-0 vd-font-semibold vd-border-0",
  "alert-success": "group vd-p-0 vd-font-semibold vd-border-0",
  "alert-caution": "group vd-p-0 vd-font-semibold vd-border-0",
  "alert-danger": "group vd-p-0 vd-font-semibold vd-border-0",
  hero: "group vd-p-0 vd-font-semibold vd-border-0",
  disabled: "group vd-p-0 vd-font-semibold vd-border-0"
}, Gt = {
  brand: `
    vd-text-btn-brand-text-icon-rest
    group-hover:vd-text-btn-brand-text-icon-hover
    focus:vd-text-btn-brand-text-icon-focused
    selected:vd-text-btn-brand-text-icon-pressed
  `,
  neutral: `
    vd-text-btn-neutral-text-icon-rest
    group-hover:vd-text-btn-neutral-text-icon-hover
    focus:vd-text-btn-neutral-text-icon-focused
    selected:vd-text-btn-neutral-text-icon-pressed
  `,
  "alert-success": `
    vd-text-btn-alert-success-text-icon-rest
    group-hover:vd-text-btn-alert-success-text-icon-hover
    focus:vd-text-btn-alert-success-text-icon-focused
    selected:vd-text-btn-alert-success-text-icon-pressed
  `,
  "alert-caution": `
    vd-text-btn-alert-caution-text-icon-rest
    group-hover:vd-text-btn-alert-caution-text-icon-hover
    focus:vd-text-btn-alert-caution-text-icon-focused
    selected:vd-text-btn-alert-caution-text-icon-pressed
  `,
  "alert-danger": `
    vd-text-btn-alert-danger-text-icon-rest
    group-hover:vd-text-btn-alert-danger-text-icon-hover
    focus:vd-text-btn-alert-danger-text-icon-focused
    selected:vd-text-btn-alert-danger-text-icon-pressed
  `,
  hero: `
    vd-text-btn-hero-text-icon-rest
    group-hover:vd-text-btn-hero-text-icon-hover
    focus:vd-text-btn-hero-text-icon-focused
    selected:vd-text-btn-hero-text-icon-pressed
  `,
  disabled: "vd-text-btn-disabled-text-icon"
}, Bt = {
  brand: `vd-text-btn-brand-text-text-rest
    hover:vd-text-btn-brand-text-text-hover
    focus:vd-text-btn-brand-text-text-focused
    selected:vd-text-btn-brand-text-text-pressed
  `,
  neutral: `vd-text-btn-neutral-text-text-rest
    hover:vd-text-btn-neutral-text-text-hover
    focus:vd-text-btn-neutral-text-text-focused
    selected:vd-text-btn-neutral-text-text-pressed
  `,
  "alert-success": `vd-text-btn-alert-success-text-text-rest
    hover:vd-text-btn-alert-success-text-text-hover
    focus:vd-text-btn-alert-success-text-text-focused
    selected:vd-text-btn-alert-success-text-text-pressed
  `,
  "alert-caution": `vd-text-btn-alert-caution-text-text-rest
    hover:vd-text-btn-alert-caution-text-text-hover
    focus:vd-text-btn-alert-caution-text-text-focused
    selected:vd-text-btn-alert-caution-text-text-pressed
  `,
  "alert-danger": `vd-text-btn-alert-danger-text-text-rest
    hover:vd-text-btn-alert-danger-text-text-hover
    focus:vd-text-btn-alert-danger-text-text-focused
    selected:vd-text-btn-alert-danger-text-text-pressed
  `,
  hero: `vd-text-btn-hero-text-text-rest
    hover:vd-text-btn-hero-text-text-rest-hover
    focus:vd-text-btn-hero-text-text-rest-focused
    selected:vd-text-btn-hero-text-text-rest-pressed
  `,
  disabled: "vd-text-btn-disabled-text-text"
}, Lt = {
  brand: `
    group
    hover:vd-border-[1px]
    hover:vd-border-solid vd-font-semibold
    hover:vd-border-btn-brand-text-fill-border-hover
    hover:vd-bg-btn-brand-text-fill-background-hover

    focus:vd-border-[2px]
    focus:vd-border-solid
    focus:vd-border-btn-brand-text-fill-border-focused
    focus:vd-bg-btn-brand-text-fill-background-focused

    vd-px-32
  `,
  neutral: `
    group
    hover:vd-border-[1px]
    hover:vd-border-solid vd-font-semibold
    hover:vd-border-btn-neutral-text-fill-border-hover
    hover:vd-bg-btn-neutral-text-fill-background-hover

    focus:vd-border-[2px]
    focus:vd-border-solid
    focus:vd-border-btn-neutral-text-fill-border-focused
    focus:vd-bg-btn-neutral-text-fill-background-focused

    vd-px-32
  `,
  "alert-success": `
    group
    hover:vd-border-[1px] font-semibold
    hover:vd-border-solid
    hover:vd-border-btn-alert-success-text-fill-border-hover
    hover:vd-bg-btn-alert-success-text-fill-background-hover

    focus:vd-border-[2px]
    focus:vd-border-solid
    focus:vd-border-btn-alert-success-outline-border-rest
    focus:vd-bg-btn-alert-success-text-fill-background-focused

    vd-px-32
  `,
  "alert-caution": `
    group
    hover:vd-border-[1px]
    hover:vd-border-solid vd-font-semibold
    hover:vd-border-btn-alert-caution-text-fill-border-hover
    hover:vd-bg-btn-alert-caution-text-fill-background-hover

    focus:vd-border-[2px]
    focus:vd-border-solid
    focus:vd-border-btn-alert-caution-text-fill-border-focused
    focus:vd-bg-btn-alert-caution-text-fill-background-focused

    vd-px-32
  `,
  "alert-danger": `
    group
    hover:vd-border-[1px]
    hover:vd-border-solid vd-font-semibold
    hover:vd-border-btn-alert-danger-text-fill-border-hover
    hover:vd-bg-btn-alert-danger-text-fill-background-hover

    focus:vd-border-[2px]
    focus:vd-border-solid
    focus:vd-border-btn-alert-danger-text-fill-border-focused
    focus:vd-bg-btn-alert-danger-text-fill-background-focused

    vd-px-32
  `,
  hero: `
    group
    hover:vd-border-[1px]
    hover:vd-border-solid vd-font-semibold
    hover:vd-border-btn-hero-text-fill-border-hover
    hover:vd-bg-btn-hero-text-fill-background-hover

    focus:vd-border-[2px]
    focus:vd-border-solid
    focus:vd-border-btn-hero-outline-border-focus
    focus:vd-bg-btn-hero-text-fill-background-focused

    vd-px-32
  `,
  disabled: "vd-font-semibold px-32 "
}, jt = {
  brand: `
    vd-text-btn-brand-text-fill-icon-rest
    group-hover:vd-text-btn-brand-text-fill-icon-hover
    focus:vd-text-btn-brand-text-fill-icon-focused
    selected:vd-text-btn-brand-text-fill-icon-pressed
  `,
  neutral: `
    vd-text-btn-neutral-text-fill-icon-rest
    group-hover:vd-text-btn-neutral-text-fill-icon-hover
    focus:vd-text-btn-neutral-text-fill-icon-focused
    selected:vd-text-btn-neutral-text-fill-icon-pressed
  `,
  "alert-success": `
    vd-text-btn-alert-success-text-fill-icon-rest
    group-hover:vd-text-btn-alert-success-text-fill-icon-hover
    focus:vd-text-btn-alert-success-text-fill-icon-focused
    selected:vd-text-btn-alert-success-text-fill-icon-pressed
  `,
  "alert-caution": `
    vd-text-btn-alert-caution-text-fill-icon-rest
    group-hover:vd-text-btn-alert-caution-text-fill-icon-hover
    focus:vd-text-btn-alert-caution-text-fill-icon-focused
    selected:vd-text-btn-alert-caution-text-fill-icon-pressed
  `,
  "alert-danger": `
    vd-text-btn-alert-danger-text-fill-icon-rest
    group-hover:vd-text-btn-alert-danger-text-fill-icon-hover
    focus:vd-text-btn-alert-danger-text-fill-icon-focused
    selected:vd-text-btn-alert-danger-text-fill-icon-pressed
  `,
  hero: `
    vd-text-btn-hero-text-fill-icon-rest
    group-hover:vd-text-btn-hero-text-fill-icon-hover
    focus:vd-text-btn-hero-text-fill-icon-focused
    selected:vd-text-btn-hero-text-fill-icon-pressed
  `,
  disabled: "vd-text-btn-disabled-text-icon"
}, Vt = {
  brand: `vd-text-btn-brand-text-text-rest
    group-hover:vd-text-btn-brand-outline-text-hover
    focus:vd-text-btn-brand-outline-text-focused
    selected:vd-text-btn-brand-outline-text-pressed
  `,
  neutral: `vd-text-btn-neutral-text-text-rest
    group-hover:vd-text-btn-neutral-text-text-hover
    focus:vd-text-btn-neutral-text-text-focused
    selected:vd-text-btn-neutral-text-text-pressed
  `,
  "alert-success": `vd-text-btn-alert-success-text-text-rest
    group-hover:vd-text-btn-alert-success-text-text-hover
    focus:vd-text-btn-alert-success-text-text-focused
    selected:vd-text-btn-alert-success-text-text-pressed
  `,
  "alert-caution": `vd-text-btn-alert-caution-text-text-rest
    group-hover:vd-text-btn-alert-caution-text-text-hover
    focus:vd-text-btn-alert-caution-text-text-focused
    selected:vd-text-btn-alert-caution-text-text-pressed
  `,
  "alert-danger": `vd-text-btn-alert-danger-text-text-rest
    group-hover:vd-text-btn-alert-danger-text-text-hover
    focus:vd-text-btn-alert-danger-text-text-focused
    selected:vd-text-btn-alert-danger-text-text-pressed
  `,
  hero: `vd-text-btn-hero-text-text-rest
    group-hover:vd-text-btn-hero-text-text-hover
    focus:vd-text-btn-hero-text-text-focused
    selected:vd-text-btn-hero-text-text-pressed
  `,
  disabled: "vd-text-btn-disabled-text-text"
}, Ft = {
  brand: `
      vd-border-[1px] vd-border-solid vd-font-semibold
      vd-border-btn-brand-outline-border-rest
      vd-bg-btn-brand-outline-background-rest
      vd-px-32 group

      hover:vd-border-[2px]
      hover:vd-border-btn-brand-outline-border-hover
      hover:vd-bg-btn-brand-outline-background-hover

      focus:vd-border-[2px]
      focus:vd-border-btn-brand-outline-border-focused
      focus:vd-bg-btn-brand-outline-background-focused

      selected:vd-border-btn-brand-outline-border-pressed
      selected:vd-bg-btn-brand-outline-background-pressed
    `,
  neutral: `
      vd-border-[1px] vd-border-solid vd-font-semibold
      vd-border-btn-neutral-outline-border-rest
      vd-bg-btn-neutral-outline-background-rest

      hover:vd-border-[2px]
      hover:vd-border-btn-neutral-outline-border-hover
      hover:vd-bg-btn-neutral-outline-background-hover

      focus:vd-border-[2px]
      focus:vd-border-btn-neutral-outline-border-focused
      focus:vd-bg-btn-neutral-outline-background-focused

      selected:vd-border-btn-neutral-outline-border-pressed
      selected:vd-bg-btn-neutral-outline-background-pressed
      vd-px-32 group
    `,
  "alert-success": `
      vd-border-[1px] vd-border-solid vd-font-semibold
      vd-border-btn-alert-success-outline-border-rest
      vd-bg-btn-alert-success-outline-background-rest

      hover:vd-border-[2px]
      hover:vd-border-btn-alert-success-outline-border-hover
      hover:vd-bg-btn-alert-success-outline-background-hover

      focus:vd-border-btn-alert-success-outline-border-focused
      focus:vd-bg-btn-alert-success-outline-background-focused

      selected:vd-border-btn-alert-success-outline-border-pressed
      selected:vd-bg-btn-alert-success-outline-background-pressed
      vd-px-32 group
    `,
  "alert-caution": `
      vd-border-[1px] vd-border-solid vd-font-semibold
      vd-border-btn-alert-caution-outline-border-rest
      vd-bg-btn-alert-caution-outline-background-rest

      hover:vd-border-[2px]
      hover:vd-border-btn-alert-caution-outline-border-hover
      hover:vd-bg-btn-alert-caution-outline-background-hover

      focus:vd-border-btn-alert-caution-outline-border-focused
      focus:vd-bg-btn-alert-caution-outline-background-focused

      selected:vd-border-btn-alert-caution-outline-border-pressed
      selected:vd-bg-btn-alert-caution-outline-background-pressed
      vd-px-32 group
    `,
  "alert-danger": `
      vd-border-[1px] vd-border-solid vd-font-semibold
      vd-border-btn-alert-danger-outline-border-rest
      vd-bg-btn-alert-danger-outline-background-rest

      hover:vd-border-[2px]
      hover:vd-border-btn-alert-danger-outline-border-hover
      hover:vd-bg-btn-alert-danger-outline-background-hover

      focus:vd-border-btn-alert-danger-outline-border-focused
      focus:vd-bg-btn-alert-danger-outline-background-focused

      selected:vd-border-btn-alert-danger-outline-border-pressed
      selected:vd-bg-btn-alert-danger-outline-background-pressed
      vd-px-32 group
    `,
  hero: `
      vd-border-[1px] vd-border-solid vd-font-semibold
      vd-border-btn-hero-outline-border-rest
      vd-bg-btn-hero-outline-background-rest

      hover:vd-border-[2px]
      hover:vd-border-btn-hero-outline-border-hover
      hover:vd-bg-btn-hero-outline-background-hover

      focus:vd-border-btn-hero-outline-border-focused
      focus:vd-bg-btn-hero-outline-background-focused

      selected:vd-border-btn-hero-outline-border-pressed
      selected:vd-bg-btn-hero-outline-background-pressed
      vd-px-32 group
    `,
  disabled: `
      vd-border-[1px] vd-border-solid vd-font-semibold
      vd-border-btn-disabled-outline-border
      vd-px-32

      hover:vd-text-btn-btn-disabled-text-text-text-text-hover
      focus:vd-text-btn-btn-disabled-text-text-text-text-focused
      selected:vd-text-btn-btn-disabled-text-text-text-text-pressed
    `
}, Ot = {
  brand: `
      vd-text-btn-brand-outline-icon-rest
      group-hover:vd-text-btn-brand-outline-icon-hover
      focus:vd-text-btn-brand-outline-icon-focused
      selected:vd-text-btn-brand-outline-icon-pressed
    `,
  neutral: `
      vd-text-btn-neutral-outline-icon-rest
      group-hover:vd-text-btn-neutral-outline-icon-hover
      focus:vd-text-btn-neutral-outline-icon-focused
      selected:vd-text-btn-neutral-outline-icon-pressed
    `,
  "alert-success": `
      vd-text-btn-alert-success-outline-icon-rest
      group-hover:vd-text-btn-alert-success-outline-icon-hover
      focus:vd-text-btn-alert-success-outline-icon-focused
      selected:vd-text-btn-alert-success-outline-icon-pressed
    `,
  "alert-caution": `
      vd-text-btn-alert-caution-outline-icon-rest
      group-hover:vd-text-btn-alert-caution-outline-icon-hover
      focus:vd-text-btn-alert-caution-outline-icon-focused
      selected:vd-text-btn-alert-caution-outline-icon-pressed
    `,
  "alert-danger": `
      vd-text-btn-alert-danger-outline-icon-rest
      group-hover:vd-text-btn-alert-danger-outline-icon-hover
      focus:vd-text-btn-alert-danger-outline-icon-focused
      selected:vd-text-btn-alert-danger-outline-icon-pressed
    `,
  hero: `
      vd-text-btn-hero-outline-icon-rest
      group-hover:vd-text-btn-hero-outline-icon-hover
      focus:vd-text-btn-hero-outline-icon-focused
      selected:vd-text-btn-hero-outline-icon-pressed
    `,
  disabled: " vd-text-btn-disabled-text-icon"
}, Wt = {
  brand: `
    vd-text-btn-brand-outline-text-rest
    group-hover:vd-text-btn-brand-outline-text-hover
    focus:vd-text-btn-brand-outline-text-focused
    selected:vd-text-btn-brand-outline-text-pressed
  `,
  neutral: `
    vd-text-btn-neutral-outline-text-rest
    group-hover:vd-text-btn-neutral-text-text-hover
    focus:vd-text-btn-neutral-text-text-focused
    selected:vd-text-btn-neutral-text-text-pressed
  `,
  "alert-success": `
    vd-text-btn-alert-success-outline-text-rest
    group-hover:vd-text-btn-alert-success-text-text-hover
    focus:vd-text-btn-alert-success-text-text-focused
    selected:vd-text-btn-alert-success-text-text-pressed
  `,
  "alert-caution": `
    vd-text-btn-alert-caution-outline-text-rest
    group-hover:vd-text-btn-alert-caution-text-text-hover
    focus:vd-text-btn-alert-caution-text-text-focused
    selected:vd-text-btn-alert-caution-text-text-pressed
  `,
  "alert-danger": `
    vd-text-btn-alert-danger-outline-text-rest
    group-hover:vd-text-btn-alert-danger-text-text-hover
    focus:vd-text-btn-alert-danger-text-text-focused
    selected:vd-text-btn-alert-danger-text-text-pressed
  `,
  hero: `
    vd-text-btn-hero-outline-text-rest
    group-hover:vd-text-btn-hero-text-text-hover
    focus:vd-text-btn-hero-text-text-focused
    selected:vd-text-btn-hero-text-text-pressed
  `,
  disabled: "vd-text-btn-disabled-text-text"
}, Ht = {
  brand: `
      group
      vd-border-[1px] vd-border-solid vd-font-semibold
      vd-border-btn-brand-solid-border-rest
      vd-bg-btn-brand-solid-background-rest

      hover:vd-border-btn-brand-solid-border-hover
      hover:vd-bg-btn-brand-solid-background-hover

      focus:vd-border-btn-brand-solid-border-focused
      focus:vd-bg-btn-brand-solid-background-focused

      selected:vd-bg-btn-brand-solid-background-pressed
      selected:vd-border-btn-brand-solid-border-pressed
      vd-px-32
    `,
  neutral: `
      vd-border-[1px] vd-border-solid vd-font-semibold
      vd-border-btn-neutral-solid-border-rest
      vd-bg-btn-neutral-solid-background-rest

      hover:vd-border-btn-neutral-solid-border-hover
      hover:vd-bg-btn-neutral-solid-background-hover

      focus:vd-border-btn-neutral-solid-border-focused
      focus:vd-bg-btn-neutral-solid-background-focused

      selected:vd-bg-btn-neutral-solid-background-pressed
      selected:vd-border-btn-neutral-solid-border-pressed
      vd-px-32 group
    `,
  "alert-success": `
      vd-border-[1px] vd-border-solid vd-font-semibold
      vd-border-btn-alert-success-solid-border-rest
      vd-bg-btn-alert-success-solid-background-rest

      hover:vd-border-btn-alert-success-solid-border-hover
      hover:vd-bg-btn-alert-success-solid-background-hover

      focus:vd-border-btn-alert-success-solid-border-focused
      focus:vd-bg-btn-alert-success-solid-background-focused

      selected:vd-bg-btn-alert-success-solid-background-pressed
      selected:vd-border-btn-alert-success-solid-border-pressed
      vd-px-32 group
    `,
  "alert-caution": `
      vd-border-[1px] vd-border-solid vd-font-semibold
      vd-border-btn-alert-caution-solid-border-rest
      vd-bg-btn-alert-caution-solid-background-rest

      hover:vd-border-btn-alert-caution-solid-border-hover
      hover:vd-bg-btn-alert-caution-solid-background-hover

      focus:vd-border-btn-alert-caution-solid-border-focused
      focus:vd-bg-btn-alert-caution-solid-background-focused

      selected:vd-bg-btn-alert-caution-solid-background-pressed
      selected:vd-border-btn-alert-caution-solid-border-pressed
      vd-px-32 group
    `,
  "alert-danger": `
      vd-border-[1px] vd-border-solid vd-font-semibold
      vd-border-btn-alert-danger-solid-border-rest
      vd-bg-btn-alert-danger-solid-background-rest

      hover:vd-border-btn-alert-danger-solid-border-hover
      hover:vd-bg-btn-alert-danger-solid-background-hover

      focus:vd-border-btn-alert-danger-solid-border-focused
      focus:vd-bg-btn-alert-danger-solid-background-focused

      selected:vd-bg-btn-alert-danger-solid-background-pressed
      selected:vd-border-btn-alert-danger-solid-border-pressed
      vd-px-32 group
    `,
  hero: `
      vd-border-[1px] vd-border-solid vd-font-semibold
      vd-border-btn-hero-solid-border-rest
      vd-bg-btn-hero-solid-background-rest

      hover:vd-border-btn-hero-solid-border-hover
      hover:vd-bg-btn-hero-solid-background-hover

      focus:vd-border-btn-hero-solid-border-focused
      focus:vd-bg-btn-hero-solid-background-focused

      selected:vd-bg-btn-hero-solid-background-pressed
      selected:vd-border-btn-hero-solid-border-pressed

      vd-px-32 group
    `,
  disabled: `
      vd-border-[1px] vd-border-solid vd-font-semibold
      vd-border-btn-disabled-solid-border
      vd-bg-btn-disabled-solid-background
      vd-px-32 group
    `
}, _t = {
  brand: `
      vd-text-btn-brand-solid-icon-rest
      group-hover:vd-text-btn-brand-solid-icon-hover
      focus:vd-text-btn-brand-solid-icon-focused
      selected:vd-text-btn-brand-solid-icon-pressed
    `,
  neutral: `
      vd-text-btn-neutral-solid-icon-rest
      group-hover:vd-text-btn-neutral-solid-icon-hover
      focus:vd-text-btn-neutral-solid-icon-focused
      selected:vd-text-btn-neutral-solid-icon-pressed
    `,
  "alert-success": `
      vd-text-btn-alert-success-solid-icon-rest
      group-hover:vd-text-btn-alert-success-solid-icon-hover
      focus:vd-text-btn-alert-success-solid-icon-focused
      selected:vd-text-btn-alert-success-solid-icon-pressed
    `,
  "alert-caution": `
      vd-text-btn-alert-caution-solid-icon-rest
      group-hover:vd-text-btn-alert-caution-solid-icon-hover
      focus:vd-text-btn-alert-caution-solid-icon-focused
      selected:vd-text-btn-alert-caution-solid-icon-pressed
    `,
  "alert-danger": `
      vd-text-btn-alert-danger-solid-icon-rest
      group-hover:vd-text-btn-alert-danger-solid-icon-hover
      focus:vd-text-btn-alert-danger-solid-icon-focused
      selected:vd-text-btn-alert-danger-solid-icon-pressed
    `,
  hero: `
      vd-text-btn-hero-solid-icon-rest
      group-hover:vd-text-btn-hero-solid-icon-hover
      focus:vd-text-btn-hero-solid-icon-focused
      selected:vd-text-btn-hero-solid-icon-pressed
    `,
  disabled: "vd-text-btn-disabled-text-icon"
}, qt = {
  brand: `
    vd-text-btn-brand-solid-text-rest
    group-hover:vd-text-btn-brand-solid-text-hover
    focus:vd-text-btn-brand-solid-text-focused
    selected:vd-text-btn-brand-solid-text-pressed
  `,
  neutral: `vd-text-btn-neutral-solid-text-rest
    group-hover:vd-text-btn-neutral-solid-text-hover
    focus:vd-text-btn-neutral-solid-text-focused
    selected:vd-text-btn-neutral-solid-text-pressed
  `,
  "alert-success": `vd-text-btn-alert-success-solid-text-rest
    group-hover:vd-text-btn-alert-success-solid-text-hover
    focus:vd-text-btn-alert-success-solid-text-focused
    selected:vd-text-btn-alert-success-solid-text-pressed
  `,
  "alert-caution": `vd-text-btn-alert-caution-solid-text-rest
    group-hover:vd-text-btn-alert-caution-solid-text-hover
    focus:vd-text-btn-alert-caution-solid-text-focused
    selected:vd-text-btn-alert-caution-solid-text-pressed
  `,
  "alert-danger": `vd-text-btn-alert-danger-solid-text-rest
    group-hover:vd-text-btn-alert-danger-solid-text-hover
    focus:vd-text-btn-alert-danger-solid-text-focused
    selected:vd-text-btn-alert-danger-solid-text-pressed
  `,
  hero: `vd-text-btn-hero-solid-text-rest
    group-hover:vd-text-btn-hero-solid-text-hover
    focus:vd-text-btn-hero-solid-text-focused
    selected:vd-text-btn-hero-solid-text-pressed
  `,
  disabled: "vd-text-btn-disabled-solid-text"
}, Ut = `
  group vd-box-border
  vd-flex vd-flex-row vd-justify-center vd-items-center
  vd-gap-x-8 vd-cursor-pointer vd-font-sans
`, Dt = {
  xxl: F.h2,
  xl: F.h3,
  l: F.b1,
  m: F.b2,
  s: F.b3
}, Jt = {
  xxl: O.h2,
  xl: O.h3,
  l: O.b1,
  m: O.b2,
  s: O.b3
}, Kt = {
  xxl: "vd-py-20 vd-h-68 sm:h-76",
  xl: "vd-py-20 vd-h-60 sm:h-68",
  l: "vd-py-16 vd-h-52 sm:h-60",
  m: "vd-py-12 vd-h-48 sm:h-52",
  s: "vd-py-8 vd-h-44 sm:h-40"
}, Xt = {
  xxl: "text-icon-32",
  xl: "text-icon-28",
  l: "text-icon-24",
  m: "text-icon-20",
  s: "text-icon-20"
}, I = ({
  fontSize: e = "b1",
  weight: r = "regular",
  spaced: t = !1,
  fontStyle: o = "roman",
  children: s,
  color: n = null,
  className: l = "",
  fontFamily: a = "sans"
}) => /* @__PURE__ */ d.createElement(
  "span",
  {
    className: u(
      Be[n],
      F[e],
      Ge[a],
      Re[o],
      Pe[r],
      l,
      t ? O[e] : ""
    )
  },
  s
), Zt = ({
  buttonType: e = "text",
  size: r = "xxl",
  variants: t = "brand",
  iconLeft: o = null,
  iconRight: s = null,
  title: n = null,
  upperCase: l = !0,
  disabled: a = !1,
  onClick: v,
  spaced: i = !1,
  ...c
}) => {
  var N, g, m, p;
  const h = {
    text: Rt,
    outline: Ft,
    solid: Ht,
    "text-fill": Lt
  }, E = {
    text: Gt,
    outline: Ot,
    solid: _t,
    "text-fill": jt
  }, f = {
    text: Bt,
    outline: Wt,
    solid: qt,
    "text-fill": Vt
  };
  return /* @__PURE__ */ d.createElement(
    "div",
    {
      ...c,
      onClick: (S) => {
        !a && v && v(S);
      },
      className: u(
        Ut,
        (N = h[e]) == null ? void 0 : N[a ? "disabled" : t],
        Kt[r],
        (c == null ? void 0 : c.className) || ""
      )
    },
    o && /* @__PURE__ */ d.createElement(
      C,
      {
        name: o,
        type: c == null ? void 0 : c.type,
        className: (g = E[e]) == null ? void 0 : g[a ? "disabled" : t]
      }
    ),
    n && /* @__PURE__ */ d.createElement(
      I,
      {
        fontSize: c.fontSize,
        weight: c.weight,
        className: `${Dt[r]}
            ${(m = f[e]) == null ? void 0 : m[t]}
            ${i ? Jt[r] : ""}
            cursor-pointer`
      },
      l ? n.toUpperCase() : n
    ),
    s && /* @__PURE__ */ d.createElement(
      C,
      {
        name: s,
        type: c == null ? void 0 : c.type,
        className: u(
          (p = E[e]) == null ? void 0 : p[a ? "disabled" : t],
          Xt[r]
        )
      }
    )
  );
}, Qt = {
  default: `vd-group vd-flex vd-cursor-pointer  vd-flex-row vd-rounded-xs vd-gap-12
  vd-bg-surface-neutral-default vd-border-[1px]
  vd-border-solid vd-border-border-neutral-subtle vd-select-none vd-rounded
  `,
  disabled: `vd-flex vd-cursor-not-allowed
  vd-vd-flex-row  vd-gap-12 vd-rounded vd-bg-background-neutral-disabled
  vd-border-[1px]
  vd-border-solid vd-border-border-neutral-disabled
  `
};
var Le = /* @__PURE__ */ ((e) => (e.xxs = "vd-px-12 vd-py-8", e.xs = "vd-px-16 vd-py-12", e))(Le || {}), se = /* @__PURE__ */ ((e) => (e.xxs = "vd-mt-2 vd-w-16 vd-h-16", e.xs = "vd-mt-2 vd-w-20 vd-h-20", e))(se || {});
const ye = `
  group-hover:vd-text-text-neutral-primary
`;
var je = /* @__PURE__ */ ((e) => (e.primary = "text-brand-medium", e))(je || {});
const Yt = "vd-flex vd-flex-col vd-gap-2 ";
var Ve = /* @__PURE__ */ ((e) => (e.default = `vd-border-[1px]
    vd-border-solid vd-border-border-neutral-subtle
    group-hover:vd-border-border-neutral-bold`, e.primary = `
    vd-border-[1px]
    vd-border-solid
    vd-border-icon-brand-soft
    group-hover:vd-border-border-brand-boldest
    hover:vd-ring-4
    hover:vd-ring-border-brand-bold/10
  `, e))(Ve || {}), le = /* @__PURE__ */ ((e) => (e.default = "vd-border-[1px] vd-border-solid vd-border-border-neutral-subtle vd-group-hover:border-border-neutral-bold vd-text-text-neutral-disabled", e.primary = "vd-border-[1px] vd-border-solid vd-border-border-brand-bold vd-text-text-brand-medium", e))(le || {}), Fe = /* @__PURE__ */ ((e) => (e.xxs = "b3", e.xs = "b2", e))(Fe || {}), Oe = /* @__PURE__ */ ((e) => (e.xxs = "caption", e.xs = "b3", e))(Oe || {});
const ro = ({
  size: e = "xs",
  variant: r = "primary",
  checked: t = !1,
  ...o
}) => {
  const s = (n) => {
    var l;
    o.disabled ? n.stopPropagation() : (l = o == null ? void 0 : o.onChange) == null || l.call(o);
  };
  return /* @__PURE__ */ d.createElement(
    "div",
    {
      onClick: s,
      className: u(
        Qt[o.disabled ? "disabled" : "default"],
        Le[e],
        Ve[t && !o.disabled ? r : "default"]
      )
    },
    o.checkboxIconPosition === "left" && /* @__PURE__ */ d.createElement(
      "input",
      {
        onChange: s,
        type: "checkbox",
        placeholder: "checkbox",
        className: u(
          "vd-form-checkbox",
          se[e],
          le[t && !o.disabled ? r : "default"]
        ),
        checked: t,
        disabled: o.disabled
      }
    ),
    /* @__PURE__ */ d.createElement("div", { className: Yt }, /* @__PURE__ */ d.createElement(
      I,
      {
        weight: "bold",
        fontSize: Fe[e],
        color: t && !o.disabled ? je[r] : "text-neutral-tertiary",
        className: ye
      },
      o.label
    ), /* @__PURE__ */ d.createElement(
      I,
      {
        weight: "regular",
        fontSize: Oe[e],
        className: u(ye)
      },
      o.subText
    )),
    o.checkboxIconPosition === "right" && /* @__PURE__ */ d.createElement(
      "input",
      {
        onChange: s,
        type: "checkbox",
        placeholder: "checkbox",
        className: u(
          "vd-form-checkbox",
          se[e],
          le[t && !o.disabled ? r : "default"]
        ),
        checked: t
      }
    )
  );
};
var We = /* @__PURE__ */ ((e) => (e.row = "vd-flex vd-flex-row sm:vd-flex-col", e.column = "vd-flex vd-flex-col sm:vd-flex-row", e))(We || {}), He = /* @__PURE__ */ ((e) => (e.none = "", e.sm = "vd-p-4", e.md = "vd-p-8", e.lg = "vd-p-12 ", e.xl = "vd-p-16", e))(He || {}), _e = /* @__PURE__ */ ((e) => (e.none = "", e.sm = "vd-m-4", e.md = "vd-m-8", e.lg = "vd-m-12", e))(_e || {});
const b = ({
  direction: e,
  padding: r = "none",
  margin: t = "none",
  className: o = "",
  ...s
}) => /* @__PURE__ */ d.createElement(
  "div",
  {
    className: u(
      "vd-flex",
      e ? We[e] : "",
      He[r],
      _e[t],
      o
    ),
    ...s
  },
  s.children
), er = {
  default: `vd-group vd-flex vd-cursor-pointer
  vd-flex-row vd-rounded-r-2 vd-gap-12
  vd-bg-surface-neutral-sunken
  vd-border-[1px]
  vd-border-solid
  vd-border-border-neutral-subtle
  vd-select-none vd-rounded
  `,
  disabled: `vd-flex vd-cursor-not-allowed
  vd-flex-row  vd-gap-12 vd-rounded vd-bg-background-neutral-disabled
  vd-border-[1px]
  vd-border-solid
  vd-border-border-neutral-disabled
  `
};
var qe = /* @__PURE__ */ ((e) => (e.xxs = "vd-px-12 vd-py-8", e.xs = "vd-px-16 vd-py-12", e))(qe || {}), ae = /* @__PURE__ */ ((e) => (e.xxs = "vd-mt-2 vd-w-16 vd-h-16", e.xs = "vd-mt-2 vd-w-20 vd-h-20", e))(ae || {});
const we = `
  group-hover:vd-text-text-neutral-primary
`;
var Ue = /* @__PURE__ */ ((e) => (e.primary = "text-brand-medium", e))(Ue || {});
const tr = "vd-flex vd-flex-col vd-gap-2 ";
var De = /* @__PURE__ */ ((e) => (e.default = `
    vd-border-[1px]
    vd-border-solid
    vd-border-border-neutral-subtle
    group-hover:vd-border-border-neutral-bold
  `, e.primary = `
    vd-border-[1px] vd-border-solid
    vd-border-icon-brand-soft
    group-hover:vd-border-border-brand-boldest
    hover:vd-ring-4
    hover:vd-ring-vd-border-brand-bold/10
  `, e))(De || {}), ce = /* @__PURE__ */ ((e) => (e.default = "vd-border-[1px] vd-border-solid vd-border-border-neutral-subtle group-hover:vd-border-border-neutral-bold", e.primary = "vd-border-[1px] vd-border-solid vd-border-border-brand-bold vd-text-text-brand-medium", e))(ce || {}), Je = /* @__PURE__ */ ((e) => (e.xxs = "b3", e.xs = "b2", e))(Je || {}), Ke = /* @__PURE__ */ ((e) => (e.xxs = "caption", e.xs = "b3", e))(Ke || {});
const oo = ({
  size: e = "xs",
  variant: r = "primary",
  checked: t = !1,
  name: o = "",
  leftComponent: s = /* @__PURE__ */ d.createElement(d.Fragment, null),
  ...n
}) => {
  const l = (a) => {
    var v;
    n.disabled ? a.stopPropagation() : (v = n == null ? void 0 : n.onChange) == null || v.call(n, { checked: t, name: o });
  };
  return /* @__PURE__ */ d.createElement(
    "div",
    {
      onClick: l,
      className: u(
        er[n.disabled ? "disabled" : "default"],
        qe[e],
        De[t && !n.disabled ? r : "default"],
        "vd-justify-between"
      )
    },
    /* @__PURE__ */ d.createElement("div", { className: "vd-flex vd-flex-row vd-gap-12" }, n.radioIconPosition === "left" && /* @__PURE__ */ d.createElement(d.Fragment, null, /* @__PURE__ */ d.createElement(
      "input",
      {
        hidden: !0,
        type: "radio",
        placeholder: "radio",
        className: u(
          "vd-form-radio",
          "vd-hidden",
          ae[e],
          ce[t && !n.disabled ? r : "default"]
        ),
        name: o,
        checked: t
      }
    ), /* @__PURE__ */ d.createElement(
      C,
      {
        name: t ? "radio-button" : "circle",
        type: t ? "fill" : "line",
        color: t ? "icon-brand-medium" : "icon-neutral-disabled"
      }
    )), /* @__PURE__ */ d.createElement("div", { className: tr }, /* @__PURE__ */ d.createElement(
      I,
      {
        weight: "bold",
        fontSize: Je[e],
        color: t && !n.disabled ? Ue[r] : "text-neutral-tertiary",
        className: we
      },
      n.label
    ), /* @__PURE__ */ d.createElement(
      I,
      {
        weight: "regular",
        fontSize: Ke[e],
        color: "text-neutral-tertiary",
        className: we
      },
      n.subText
    ))),
    /* @__PURE__ */ d.createElement("div", { className: "vd-flex vd-flex-col" }, s),
    n.radioIconPosition === "right" && /* @__PURE__ */ d.createElement(d.Fragment, null, /* @__PURE__ */ d.createElement(
      "input",
      {
        hidden: !0,
        type: "radio",
        placeholder: "radio",
        className: u(
          "vd-form-radio",
          "vd-hidden",
          ae[e],
          ce[t && !n.disabled ? r : "default"]
        ),
        name: o,
        checked: t
      }
    ), /* @__PURE__ */ d.createElement(
      C,
      {
        name: t ? "radio-button" : "circle",
        type: t ? "fill" : "line",
        color: t ? "icon-brand-medium" : "icon-neutral-disabled"
      }
    ))
  );
}, rr = "vd-bg-gradient-to-r vd-inline-block vd-text-icon-accent-v1-strong/0 vd-bg-clip-text", or = "vd-relative vd-flex vd-bg-background-neutral-subtler vd-rounded-r-12 vd-items-center vd-justify-center", ke = {
  primary: "vd-from-background-brand-boldest vd-to-background-brand-bold"
}, dr = {
  lg: "vd-w-64 vd-h-64"
}, nr = {
  primary: " hover:vd-border hover:vd-border-border-brand-bold"
}, sr = {
  xxs: "vd-absolute vd-p-2 vd-rounded-r-8 -vd-top-[8px] -vd-right-[6px] vd-bg-gradient-to-t vd-flex vd-items-center vd-justify-center vd-text-text-neutral-inverse-primary",
  xs: ""
}, no = ({
  iconSize: e = "lg",
  badgeIconSize: r = "xxs",
  badgeIconName: t = "graduation-cap",
  name: o = "code-simple",
  color: s = "primary"
}) => /* @__PURE__ */ d.createElement(
  "div",
  {
    className: u(
      or,
      nr[s],
      dr[e]
    )
  },
  /* @__PURE__ */ d.createElement(
    C,
    {
      iconSize: e,
      name: o,
      className: u(rr, ke[s])
    }
  ),
  t ? /* @__PURE__ */ d.createElement(
    "div",
    {
      className: u(sr[r], ke[s])
    },
    /* @__PURE__ */ d.createElement(
      C,
      {
        name: t,
        iconSize: r,
        color: "icon-neutral-inverse-strong"
      }
    )
  ) : null
), lr = {
  xxs: "vd-h-24 sm:vd-h-28 vd-gap-x-8 vd-px-12",
  xs: "vd-h-32 vd-gap-x-8 vd-px-12",
  s: "vd-h-44 sm:vd-h-40 vd-gap-x-8 vd-px-16",
  m: "vd-h-48 sm:vd-h-52 vd-gap-x-12 vd-px-20",
  l: "vd-h-60 vd-h-53 vd-gap-x-12 vd-px-24"
}, ar = {
  xxs: "caption",
  xs: "b3",
  s: "b3",
  m: "b2",
  l: "b1"
}, de = {
  xxs: "xxs",
  xs: "xxs",
  s: "xxs",
  m: "xxs",
  l: "xxs"
}, cr = `
  vd-border-[1px] vd-border-solid
  vd-border-border-neutral-disabled
  vd-bg-surface-neutral-default-disabled
`, ir = "vd-text-text-neutral-disabled", ur = "icon-neutral-disabled", V = "vd-border-[1px] vd-border-solid", vr = {
  brand: `
    ${V} vd-border-solid vd-border-neutral-subtler
    vd-bg-surface-neutral-elevate-lower
    hover:vd-border-border-brand-subtlest
    hover:vd-bg-background-brand-subtlest
  `,
  neutral: `
    ${V} vd-border-border-neutral-subtler
    vd-bg-surface-neutral-elevate-lower
    hover:vd-border-border-neutral-subtle
    hover:vd-bg-surface-neutral-elevate-low
  `,
  hero: `
    ${V} vd-border-border-neutral-subtler
    vd-bg-surface-neutral-elevate-lower
    hover:vd-border-border-alert-success-subtlest
    hover:vd-bg-background-accent-secondary-subtlest
  `,
  "alert-danger": `
    ${V} vd-border-border-alert-danger-subtlest
    vd-bg-background-alert-danger-subtlest
    hover:vd-border-tags-vd-border-alert-danger-subtle
  `,
  "alert-caution": `
    ${V} vd-border-border-alert-caution-subtlest
    vd-bg-background-alert-caution-subtlest
    hover: vd-border-tags-vd-border-alert-caution-subtle
  `,
  "alert-success": `
    ${V} vd-border-border-alert-success-subtlest
    vd-bg-background-alert-success-subtlest
    hover: vd-border-tags-vd-border-alert-success-subtle
  `
}, br = {
  brand: `
  vd-text-text-neutral-tertiary
  hover:vd-text-text-neutral-primary
  `,
  neutral: `
    vd-text-text-neutral-secondary
    hover:vd-text-text-neutral-primary
  `,
  hero: `
    vd-text-text-neutral-tertiary
    hover:vd-text-text-neutral-primary
  `,
  "alert-danger": `
    vd-text-tags-text-tags-text-alert-danger
  `,
  "alert-caution": `
    vd-text-tags-text-tags-text-alert-caution
  `,
  "alert-success": `
    vd-text-tags-text-tags-text-alert-success
  `
}, xr = {
  brand: "vd-bg-tags-background-brand-subtle",
  neutral: `
    ${V}
    vd-border-border-neutral-boldest
    vd-bg-surface-neutral-inverse-elevate-low
  `,
  hero: "vd-bg-tags-background-hero-subtle",
  "alert-danger": "vd-bg-tags-background-alert-danger-bold",
  "alert-success": "vd-bg-tags-background-alert-tags-background-alert-success-bold",
  "alert-caution": "vd-bg-tags-background-alert-tags-background-alert-caution-bold"
}, fr = {
  brand: "vd-text-tags-text-neutral-primary-inverse-strong",
  neutral: "vd-text-text-neutral-inverse-primary",
  hero: "vd-text-tags-text-neutral-primary-inverse-strong",
  "alert-danger": "vd-text-tags-text-neutral-primary-inverse-strong",
  "alert-caution": "vd-text-tags-text-neutral-primary-inverse-strong",
  "alert-success": "vd-text-tags-text-neutral-primary-inverse-strong"
}, gr = {
  inactive: "icon-neutral-soft",
  active: "icon-neutral-inverse-strong"
}, T = "vd-border-[1px] vd-border-solid", mr = {
  brand: `
    ${T} vd-border-border-neutral-subtlest
    hover:vd-border-border-brand-subtlest
    hover:vd-bg-background-brand-subtlest
  `,
  neutral: `
    ${T} vd-border-border-neutral-subtlest
    hover:vd-border-border-neutral-bold
    hover:vd-bg-surface-neutral-elevate-low
  `,
  hero: `
    ${T} vd-border-border-neutral-subtlest
    hover:vd-border-border-alert-success-subtlest
    hover:vd-bg-background-accent-secondary-subtlest
  `,
  "alert-danger": `
    ${T} vd-border-border-alert-danger-subtlest
    hover:vd-border-border-alert-danger-subtler
    hover:vd-bg-background-alert-danger-subtlest
  `,
  "alert-caution": `
    ${T} vd-border-border-alert-caution-subtlest
    hover:vd-border-border-alert-caution-subtler
    hover:vd-bg-background-alert-caution-subtlest
  `,
  "alert-success": `
    ${T} vd-border-border-alert-success-subtlest
    hover:vd-border-border-alert-success-subtler
    hover:vd-bg-background-alert-success-subtlest
  `
}, pr = {
  brand: "vd-text-text-neutral-tertiary hover:vd-text-text-brand-soft",
  neutral: "vd-text-text-neutral-tertiary hover:vd-text-text-neutral-primary",
  hero: "vd-text-text-neutral-tertiary hover:vd-text-text-accent-secondary-soft",
  "alert-danger": "vd-text-text-alert-danger-soft hover:text-tags-text-tags-text-alert-danger",
  "alert-caution": "vd-text-text-alert-caution-soft hover:text-tags-text-tags-text-alert-caution",
  "alert-success": "vd-text-text-alert-success-soft hover:text-tags-text-tags-text-alert-success"
}, hr = {
  brand: ` ${T} vd-border-tags-vd-border-brand-subtle`,
  neutral: `${T} vd-border-border-neutral-bold`,
  hero: `${T} vd-border-tags-vd-border-hero-subtle`,
  "alert-danger": `${T} vd-border-tags-vd-border-alert-danger-subtle`,
  "alert-success": `${T} vd-border-tags-vd-border-alert-success-subtle`,
  "alert-caution": `${T}vd-border-tags-vd-border-alert-caution-subtle`
}, yr = {
  brand: "vd-text-text-brand-soft",
  neutral: "vd-text-text-neutral-primary",
  hero: "vd-text-text-accent-secondary-soft",
  "alert-danger": "vd-text-text-alert-danger-soft",
  "alert-caution": "vd-text-text-alert-caution-soft",
  "alert-success": "vd-text-text-alert-success-soft"
}, wr = {
  inactive: "icon-neutral-soft",
  active: "icon-neutral-soft"
}, kr = "vd-flex-row vd-items-center vd-cursor-pointer", so = ({
  tagVariant: e = "brand",
  tagType: r = "fill",
  tagSize: t = "m",
  interactive: o = !1,
  disabled: s = !1,
  label: n,
  spaced: l = !1,
  onClose: a,
  onClick: v,
  ...i
}) => {
  var f, N, g, m, p, S, z, $, M, B, L, y;
  const c = {
    fill: {
      style: vr,
      textStyle: br,
      selectedStyle: xr,
      selectedTextStyle: fr,
      iconStyle: gr
    },
    outline: {
      style: mr,
      textStyle: pr,
      selectedStyle: hr,
      selectedTextStyle: yr,
      iconStyle: wr
    }
  };
  let h = (N = (f = c[r]) == null ? void 0 : f.iconStyle) == null ? void 0 : N[i != null && i.active ? "active" : "inactive"], E = u(
    i != null && i.active ? (S = (p = c[r]) == null ? void 0 : p.selectedTextStyle) == null ? void 0 : S[e] : (m = (g = c[r]) == null ? void 0 : g.textStyle) == null ? void 0 : m[e]
  );
  return s && (h = ur, E = ir), /* @__PURE__ */ d.createElement(
    b,
    {
      className: u(
        kr,
        lr[t],
        !(i != null && i.active) && !s ? ($ = (z = c[r]) == null ? void 0 : z.style) == null ? void 0 : $[e] : (B = (M = c[r]) == null ? void 0 : M.selectedStyle) == null ? void 0 : B[e],
        s ? cr : ""
      )
    },
    /* @__PURE__ */ d.createElement("div", { onClick: v }, i.iconLeft && /* @__PURE__ */ d.createElement(
      C,
      {
        color: h,
        name: i.iconLeft,
        type: i.type,
        iconSize: de[t]
      }
    ), /* @__PURE__ */ d.createElement(
      I,
      {
        weight: i.weight,
        spaced: l,
        fontSize: ar[t],
        className: E
      },
      n
    )),
    o && /* @__PURE__ */ d.createElement(b, { className: "vd-z-10", onClick: a }, /* @__PURE__ */ d.createElement(
      C,
      {
        color: h,
        name: "x",
        type: "fill",
        iconSize: de[t]
      }
    )),
    i.iconRight && /* @__PURE__ */ d.createElement(
      C,
      {
        color: (y = (L = c[r]) == null ? void 0 : L.iconStyle) == null ? void 0 : y[i != null && i.active ? "active" : "inactive"],
        name: i.iconRight,
        type: "fill",
        iconSize: de[t]
      }
    )
  );
}, Er = {
  xxl: "h2",
  xl: "h3",
  l: "b1",
  m: "b2",
  xs: "b3",
  xxs: "caption"
}, Nr = {
  xxl: "xl",
  xl: "lg",
  l: "md",
  m: "sm",
  xs: "xxs",
  xxs: "xxs"
}, lo = ({
  listItemSize: e,
  className: r = "",
  ...t
}) => /* @__PURE__ */ d.createElement(
  b,
  {
    onClick: t == null ? void 0 : t.onClick,
    className: u("vd-flex-row vd-items-center vd-gap-x-8", r)
  },
  /* @__PURE__ */ d.createElement(
    C,
    {
      name: t.name,
      type: t.type,
      iconSize: e ? Nr[e] : t == null ? void 0 : t.iconSize,
      color: t.iconColor
    }
  ),
  /* @__PURE__ */ d.createElement(
    I,
    {
      weight: t.weight,
      spaced: t.spaced,
      color: t.fontColor,
      fontSize: e ? Er[e] : t == null ? void 0 : t.fontSize
    },
    t == null ? void 0 : t.label
  )
), Sr = {
  xxs: "vd-h-24 sm:vd-h-28 vd-gap-x-8 vd-px-12",
  xs: "vd-h-32 vd-gap-x-8 vd-px-12",
  s: "vd-h-44 sm:vd-h-40 vd-gap-x-8 vd-px-16"
}, Cr = {
  xxs: "caption",
  xs: "b3",
  s: "b3"
}, Ee = {
  xxs: "xxs",
  xs: "xxs",
  s: "xxs"
}, $r = {
  brand: "vd-bg-background-brand-subtler",
  neutral: "vd-bg-surface-neutral-elevate-low",
  hero: "vd-bg-background-accent-secondary-subtler",
  "alert-danger": "vd-bg-background-alert-danger-subtler",
  "alert-caution": "vd-bg-background-alert-caution-subtler",
  "alert-success": "vd-bg-background-alert-success-subtler"
}, Ir = {
  brand: "text-brand-strong",
  neutral: "text-neutral-tertiary",
  hero: "text-accent-secondary-strong",
  "alert-danger": "text-alert-danger-strong",
  "alert-caution": "text-alert-caution-strong",
  "alert-success": "text-alert-success-strong"
}, Ne = {
  brand: "icon-neutral-soft",
  neutral: "icon-neutral-soft",
  hero: "icon-accent-secondary-strong",
  "alert-danger": "icon-alert-danger-strong",
  "alert-caution": "icon-alert-caution-strong",
  "alert-success": "icon-alert-success-strong"
}, ao = ({
  label: e,
  labelSize: r = "xxs",
  labelVariant: t = "brand",
  ...o
}) => /* @__PURE__ */ d.createElement(
  b,
  {
    className: u(
      "vd-flex-row vd-items-center",
      $r[t],
      Sr[r]
    )
  },
  o.iconLeft && /* @__PURE__ */ d.createElement(
    C,
    {
      color: Ne[t],
      name: o.iconLeft,
      type: o.type,
      iconSize: Ee[r]
    }
  ),
  /* @__PURE__ */ d.createElement(
    I,
    {
      weight: o.weight,
      spaced: o.spaced,
      fontSize: Cr[r],
      color: Ir[t]
    },
    e
  ),
  o.iconRight && /* @__PURE__ */ d.createElement(
    C,
    {
      color: Ne[t],
      name: o.iconRight,
      type: o.type,
      iconSize: Ee[r]
    }
  )
), zr = `vd-flex-1 vd-absolute vd-left-2
    vd-top-2 vd-h-screen vd-justify-center vd-w-screen vd-bg-background-neutral-inverse-boldest/25`, co = ({
  children: e,
  isOpen: r,
  containerClass: t = ""
}) => r ? /* @__PURE__ */ d.createElement(b, { className: "vd-relative" }, /* @__PURE__ */ d.createElement(b, { className: u(zr, t) }, /* @__PURE__ */ d.createElement(b, { className: "vd-place-self-center" }, e))) : null, Tr = `
  vd-flex-col-reverse sm:vd-flex-row
  vd-flex-1 vd-justify-between
  vd-gap-y-16 sm:vd-gap-x-16
  vd-p-20 vd-bg-background-brand-boldest
  `, io = ({
  title: e,
  description: r,
  ctaComponents: t,
  mediaComponent: o,
  ctaContainerClass: s = "",
  containerClass: n = "",
  mediaContainerClass: l = ""
}) => /* @__PURE__ */ d.createElement(b, { className: u(Tr, n) }, /* @__PURE__ */ d.createElement(b, { className: "vd-flex-col vd-flex-1 vd-gap-y-8" }, e, r, /* @__PURE__ */ d.createElement(b, { className: u("vd-mt-8 sm:vd-self-start", s) }, t)), o ? /* @__PURE__ */ d.createElement(b, null, /* @__PURE__ */ d.createElement(b, { className: l }, o)) : null), Mr = `vd-fixed
vd-bg-surface-neutral-sunken vd-z-100
vd-shadow-u-4h  vd-bottom-none vd-w-full vd-h-2/3 vd-left-none vd-right-none`, uo = ({
  isOpen: e,
  className: r,
  children: t,
  onClose: o,
  closeButtonClass: s
}) => /* @__PURE__ */ d.createElement(b, { className: "vd-z-[9999]" }, e && /* @__PURE__ */ d.createElement(b, { className: u(Mr, r) }, t, /* @__PURE__ */ d.createElement(
  b,
  {
    onClick: o,
    className: u("vd-bg-surface-neutral-sunken", s)
  },
  /* @__PURE__ */ d.createElement(
    C,
    {
      name: "x-square",
      color: "icon-neutral-inverse-soft",
      iconSize: "lg"
    }
  )
))), Ar = {
  sm: "vd-px-12 vd-py-4 vd-h-32",
  md: "vd-px-16 vd-py-4 vd-h-52",
  lg: "vd-px-20 vd-py-4 vd-h-60"
}, Pr = `
vd-items-center group
vd-border-[1px] vd-border-solid vd-border-border-neutral-subtle
vd-bg-surface-neutral-elevate-lower
vd-text-text-neutral-tertiary vd-font-sans

hover:vd-border-border-neutral-bolder
hover:vd-bg-surface-neutral-elevate-low

focus:vd-ring-border-brand-subtler
focus:vd-bg-surface-neutral-default

`, Rr = `
  vd-p-0 vd-m-0 vd-ring-0 vd-border-0 vd-w-full
  vd-text-text-neutral-primary
  group-focus:vd-border-[0px] vd-bg-background-neutral-bold/0
`, vo = ({
  size: e = "sm",
  iconLeft: r,
  suffixText: t,
  iconRight: o,
  clearInput: s,
  onClearInput: n,
  cta: l,
  onClick: a,
  ...v
}) => /* @__PURE__ */ d.createElement(b, { className: u(Ar[e], Pr) }, r && /* @__PURE__ */ d.createElement(C, { name: r, color: "icon-neutral-soft", iconSize: "xs" }), /* @__PURE__ */ d.createElement(
  "input",
  {
    ...v,
    className: u("vd-form-input  vd-selected ", Rr),
    title: ""
  }
), /* @__PURE__ */ d.createElement(b, { className: "vd-justify-center vd-items-center vd-gap-x-12" }, t && /* @__PURE__ */ d.createElement(I, { color: "text-neutral-tertiary" }, t), s && /* @__PURE__ */ d.createElement(b, { onClick: n }, /* @__PURE__ */ d.createElement(C, { name: "x", color: "icon-neutral-soft", iconSize: "xs" })), o && /* @__PURE__ */ d.createElement(C, { name: o, color: "icon-neutral-soft", iconSize: "xs" }), l && /* @__PURE__ */ d.createElement(
  Zt,
  {
    size: "s",
    onClick: a,
    title: l,
    variants: "brand",
    buttonType: "text"
  }
))), Gr = {
  arrow: {
    collapsedStateIcon: "plus",
    unCollapsedStateIcon: "minus"
  },
  "non-arrow": {
    collapsedStateIcon: "caret-down",
    unCollapsedStateIcon: "caret-up"
  }
}, bo = ({
  topLeftLabelContainer: e,
  topRightLabelConatiner: r,
  showCollapsable: t,
  collapsibleIconGroup: o,
  tagLeftContainer: s,
  tagRightContainer: n,
  titleContainer: l,
  descriptionContainer: a,
  bottomLeftLabelConatiner: v,
  headerContainerClass: i = "",
  bodyContainerClass: c,
  tagContainerClass: h = "",
  labelContainerClass: E = "",
  className: f,
  children: N,
  defaultOpenState: g = !1,
  onAccordionClick: m
}) => {
  const [p, S] = te(g), z = Xe(() => {
    t && (m && m(p), S(!p));
  }, [p, m, t]), { collapsedStateIcon: $, unCollapsedStateIcon: M } = Gr[o];
  return /* @__PURE__ */ d.createElement(b, { className: u("vd-flex-col vd-p-16 vd-gap-y-16", f) }, /* @__PURE__ */ d.createElement(
    b,
    {
      className: u("vd-flex-col vd-gap-y-8", i),
      onClick: z
    },
    /* @__PURE__ */ d.createElement(
      b,
      {
        className: u("vd-flex-row vd-justify-between", E)
      },
      e,
      /* @__PURE__ */ d.createElement(b, { className: "vd-col-row vd-gap-16 vd-self-end" }, r, t && /* @__PURE__ */ d.createElement(b, null, /* @__PURE__ */ d.createElement(
        C,
        {
          name: p ? M : $,
          className: "vd-py-12 vd-px-4"
        }
      )))
    ),
    /* @__PURE__ */ d.createElement(
      b,
      {
        className: u("vd-flex-row vd-justify-between", h)
      },
      /* @__PURE__ */ d.createElement(b, { className: "vd-self-start vd-gap-x-8" }, s),
      /* @__PURE__ */ d.createElement(b, { className: "vd-self-end vd-gap-x-8" }, n)
    ),
    /* @__PURE__ */ d.createElement(b, { className: "vd-flex-col vd-gap-y-8" }, l, a),
    v
  ), p && /* @__PURE__ */ d.createElement(b, { className: c }, p && /* @__PURE__ */ d.createElement(d.Fragment, null, N)));
}, Se = ({
  titleComponent: e,
  descriptionComponent: r,
  description: t,
  title: o,
  contentContainerClass: s
}) => /* @__PURE__ */ d.createElement(b, { className: u("vd-flex-col", s) }, e || /* @__PURE__ */ d.createElement(
  I,
  {
    color: "text-neutral-disabled",
    fontSize: "caption",
    weight: "semibold"
  },
  o
), r || /* @__PURE__ */ d.createElement(I, { color: "text-neutral-primary", fontSize: "b3", weight: "semibold" }, t)), Br = ({
  title: e,
  titleComponent: r,
  description: t,
  iconComponent: o,
  descriptionComponent: s,
  contentContainerClass: n,
  containerClass: l,
  iconContainerClass: a,
  disabled: v,
  onClick: i,
  hidden: c
}) => c ? /* @__PURE__ */ d.createElement(
  Se,
  {
    contentContainerClass: n,
    title: e,
    titleComponent: r,
    description: t,
    descriptionComponent: s
  }
) : /* @__PURE__ */ d.createElement(
  "li",
  {
    onClick: i,
    className: u(
      "vd-mb-[10px] vd-ms-[1px] vd-pb-48 vd-list-none",
      l
    )
  },
  /* @__PURE__ */ d.createElement(
    "span",
    {
      className: u(
        `vd-absolute vd-flex vd-items-center vd-justify-center 
            vd-bg-background-brand-subtlest vd-p-8
            vd-rounded-r-full
            -vd-start-[20px] vd-ring-8 vd-ring-surface-neutral-base`,
        v ? "vd-bg-background-neutral-subtlest" : "vd-bg-background-brand-subtlest",
        a
      )
    },
    o
  ),
  /* @__PURE__ */ d.createElement(
    Se,
    {
      contentContainerClass: n,
      title: e,
      titleComponent: r,
      description: t,
      descriptionComponent: s
    }
  )
), Lr = ({
  children: e,
  containerClass: r,
  hidden: t
}) => t ? /* @__PURE__ */ d.createElement(b, { className: u("vd-flex-col vd-gap-16", r) }, e) : /* @__PURE__ */ d.createElement(
  "ol",
  {
    className: u(
      "vd-relative vd-border-l-[1px] vd-border-[0px] vd-border-dashed vd-border-border-neutral-subtler",
      r
    )
  },
  e
);
Lr.Item = Br;
const jr = {
  sm: "sm:vd-h-22 vd-h-20 sm:vd-py-12 vd-px-8 vd-py-16",
  md: "sm:vd-h-26 vd-h-22 sm:vd-py-12 vd-px-8 vd-py-16",
  lg: "sm:vd-h-28 vd-py-16 vd-px-12"
}, Vr = `
  vd-bg-surface-neutral-default vd-gap-12
  hover:vd-bg-surface-neutral-elevate-low
`, Fr = "vd-items-center vd-cursor-pointer", Ce = ({
  label: e,
  value: r,
  onClick: t,
  size: o,
  handleClose: s,
  ...n
}) => {
  const l = {
    xxs: "b3",
    xs: "b3",
    s: "b2",
    m: "b2",
    l: "b1"
  }, a = {
    xxs: "xxs",
    xs: "xxs",
    s: "xs",
    m: "xs",
    l: "sm"
  }, v = {
    xxs: "sm",
    xs: "sm",
    s: "md",
    m: "md",
    l: "lg"
  };
  return /* @__PURE__ */ d.createElement(
    "div",
    {
      key: n.key,
      className: u(
        Fr,
        jr[v[o]],
        n != null && n.isActive ? "vd-bg-background-brand-subtlest" : Vr
      ),
      onClick: () => {
        s == null || s(), t == null || t(r);
      }
    },
    n.iconLeft && /* @__PURE__ */ d.createElement(
      C,
      {
        color: "icon-neutral-medium",
        iconSize: a[o],
        name: n.iconLeft
      }
    ),
    /* @__PURE__ */ d.createElement(I, { color: "text-neutral-primary", fontSize: l[o] }, e)
  );
}, Or = `
  vd-absolute vd-p-16 vd-border-solid
  vd-border-[1px] vd-overflow-y-auto vd-flex-col
  vd-w-full vd-max-h-224 vd-mt-4
  vd border-[1px] vd-border-border-neutral-subtle
  vd-bg-surface-neutral-sunken vd-z-[999] vd-shadow-16h
`, Wr = ({
  children: e,
  className: r = "",
  ref: t
}) => /* @__PURE__ */ d.createElement("div", { className: u(Or, r), ref: t }, e), Hr = "vd-flex vd-items-center vd-justify-between vd-cursor-pointer", _r = {
  xxs: "sm:vd-h-28 vd-h-24 vd-px-12",
  xs: "sm:vd-h-32 vd-h-32 vd-px-12",
  s: "sm:vd-h-40 vd-h-44 vd-px-12",
  m: "sm:vd-h-52 vd-h-48 vd-px-16",
  l: "sm:vd-h-60 vd-h-52 vd-px-20"
}, qr = {
  xxs: "caption",
  xs: "b3",
  s: "b2",
  m: "b2",
  l: "b1"
}, Ur = {
  outline: {
    default: `
      vd-bg-surface-neutral-elevate-lower
      vd-border-[1px]
      vd-border-solid
      vd-border-border-neutral-subtle

      hover:vd-bg-surface-neutral-elevate-low
      hover:vd-bg-border-border-neutral-bolder
    `
  },
  fill: {
    default: `
     vd-bg-surface-neutral-elevate-lower
      hover:vd-bg-surface-neutral-elevate-low
      hover:vd-bg-border-border-neutral-bolder
    `
  }
}, Dr = {
  outline: {
    default: "text-neutral-secondary",
    disabled: "text-neutral-disabled",
    active: "text-neutral-primary"
  },
  fill: {
    default: "text-neutral-secondary",
    disabled: "text-neutral-disabled",
    active: "text-neutral-primary"
  }
}, Jr = `
 vd-border-[1px] vd-border-solid vd-border-border-brand-bold
`, $e = {
  default: `
    vd-border-[0px]
    vd-border-border-neutral-subtle vd-border-dashed
    vd-border-l-[1px]
`,
  active: `
  vd-border-[0px]
  vd-border-border-brand-bold vd-border-dashed
  vd-border-l-[1px]
`
}, Kr = ({
  value: e,
  placeholder: r,
  iconLeft: t,
  isOpen: o,
  onOpen: s,
  variant: n,
  size: l,
  dashed: a,
  name: v,
  spaced: i = !1,
  autoComplete: c = !1,
  onValueChange: h,
  required: E,
  inputContainerClass: f,
  inputClassName: N,
  iconClassName: g
}) => {
  const [m, p] = te(""), S = () => s(!o), z = ($) => {
    p($), h($);
  };
  return Y(() => {
    p(e), h(e);
  }, [e]), /* @__PURE__ */ d.createElement(
    "div",
    {
      className: u(
        Hr,
        Ur[n].default,
        _r[l],
        o ? Jr : "",
        f
      ),
      onClick: () => {
        c || S();
      }
    },
    t && /* @__PURE__ */ d.createElement("div", { className: "vd-flex vd-items-center" }, /* @__PURE__ */ d.createElement(C, { color: "icon-neutral-soft", iconSize: "xxs", name: t })),
    !c && /* @__PURE__ */ d.createElement("input", { name: v, value: e, className: "vd-hidden" }),
    c && /* @__PURE__ */ d.createElement(
      "input",
      {
        type: "text",
        name: v,
        className: u(
          `vd-form-input vd-border-[0px] vd-bg-background-neutral-bold/0
          focus:vd-ring-0
          vd-font-sans vd-text-text-neutral-primary`,
          N
        ),
        value: m,
        placeholder: r,
        onChange: ($) => {
          o || s(!0), z($.target.value);
        },
        required: E
      }
    ),
    !c && /* @__PURE__ */ d.createElement("div", null, /* @__PURE__ */ d.createElement(
      I,
      {
        fontSize: qr[l],
        color: Dr[n].default,
        spaced: i,
        className: "vd-pr-8"
      },
      e || r
    )),
    /* @__PURE__ */ d.createElement(
      "div",
      {
        className: u(
          "vd-ml-8 vd-pl-8",
          a ? o ? $e.active : $e.default : "",
          g
        ),
        onClick: S
      },
      o ? /* @__PURE__ */ d.createElement(C, { color: "icon-neutral-soft", iconSize: "xxs", name: "caret-up" }) : /* @__PURE__ */ d.createElement(C, { color: "icon-neutral-soft", iconSize: "xxs", name: "caret-down" })
    )
  );
}, Xr = (e) => /* @__PURE__ */ d.createElement("div", null, !(e != null && e.showGroup) && /* @__PURE__ */ d.createElement(I, { color: "text-neutral-tertiary", weight: "bold", fontSize: "caption" }, e.label), e.children), xo = ({
  value: e,
  placeholder: r,
  size: t = "s",
  variant: o = "outline",
  dashed: s,
  selectContainerClass: n = "",
  iconLeft: l,
  spaced: a = !1,
  options: v,
  onChange: i,
  autoComplete: c,
  containerClass: h,
  isLoading: E = !1,
  ...f
}) => {
  const [N, g] = te(!1), m = fe(null), p = fe(null), [S, z] = te([]), $ = (y) => {
    m.current && !m.current.contains(y.target) && g(!1);
  };
  Y(() => (document.addEventListener("click", $), () => {
    document.removeEventListener("click", $);
  }), []), Y(() => {
    if (N && p.current) {
      const y = p.current.querySelector(".active");
      y && (p.current.scrollTop = y.offsetTop - 72);
    }
  }, [N]), Y(() => {
    z(v);
  }, [v]);
  function M(y, j) {
    let A;
    return function(..._) {
      clearTimeout(A), A = setTimeout(() => y.apply(this, _), j);
    };
  }
  function B(y) {
    const j = v.filter(
      (A) => A.name.includes(y) || A.value.includes(y)
    );
    z(y !== "" || y ? j : v);
  }
  const L = M(B, 500);
  return /* @__PURE__ */ d.createElement(
    "div",
    {
      className: u("vd-flex-col vd-relative", h),
      ref: m
    },
    /* @__PURE__ */ d.createElement(
      Kr,
      {
        name: f.name,
        value: e,
        placeholder: r,
        variant: o,
        size: t,
        dashed: s,
        spaced: a,
        iconLeft: l,
        autoComplete: c,
        required: f == null ? void 0 : f.required,
        inputClassName: f == null ? void 0 : f.inputClassName,
        iconClassName: f == null ? void 0 : f.iconClassName,
        inputContainerClass: f == null ? void 0 : f.inputContainerClass,
        onValueChange: (y) => {
          c && (L(y), i(y));
        },
        isOpen: N,
        onOpen: (y) => {
          g(y);
        }
      }
    ),
    N && /* @__PURE__ */ d.createElement(Wr, { ref: p, className: n }, E ? /* @__PURE__ */ d.createElement(
      Ce,
      {
        size: t,
        key: "Loading...",
        label: "Loading...",
        value: "Loading...",
        onClick: () => {
        }
      }
    ) : /* @__PURE__ */ d.createElement(Xr, { label: f.label, showGroup: f.showGroup }, S.map((y) => /* @__PURE__ */ d.createElement(
      Ce,
      {
        size: t,
        key: y.name,
        label: y.name,
        value: y.value,
        onClick: () => {
          i == null || i(y), g(!1);
        }
      }
    ))))
  );
}, fo = ({
  imageUrl: e = "",
  className: r,
  imageContainerClass: t = "",
  contentComponent: o,
  footerComponent: s,
  footerContainerClass: n = "",
  imageComponent: l = null,
  ...a
}) => /* @__PURE__ */ d.createElement(
  b,
  {
    key: a == null ? void 0 : a.key,
    className: u(
      "vd-flex-col vd-max-w-[392px] vd-bg-surface-neutral-elevate-low",
      r
    )
  },
  /* @__PURE__ */ d.createElement(
    b,
    {
      className: u(
        "vd-w-full vd-h-[216px] vd-bg-background-brand-subtle",
        t
      )
    },
    l || /* @__PURE__ */ d.createElement("img", { width: "100%", alt: "image", src: e, className: t })
  ),
  o,
  s && /* @__PURE__ */ d.createElement(
    b,
    {
      className: u(
        "vd-flex-1 vd-pb-16 vd-px-16 vd-mt-8 vd-bg-accent-v1-80",
        n
      )
    },
    s
  )
), go = ({
  avatarUrl: e,
  avatarClass: r,
  contentComponent: t,
  titleComponent: o,
  tagComponent: s,
  containerClass: n = "",
  footerComponent: l,
  footerContainerClass: a,
  headerClass: v,
  imageComponent: i = null,
  ...c
}) => /* @__PURE__ */ d.createElement(b, { key: c == null ? void 0 : c.key, className: u("vd-flex-col ", n) }, /* @__PURE__ */ d.createElement(b, { className: u("vd-p-24 vd-gap-x-16", v) }, /* @__PURE__ */ d.createElement(
  b,
  {
    className: u(
      "vd-min-w-104 vd-overflow-hidden vd-w-104 vd-h-104 vd-bg-background-brand-boldest",
      r
    )
  },
  i || /* @__PURE__ */ d.createElement(
    "img",
    {
      alt: "image",
      src: e,
      className: u("vd-object-contain", r)
    }
  )
), /* @__PURE__ */ d.createElement(b, { className: "vd-flex-col vd-gap-y-8" }, /* @__PURE__ */ d.createElement(b, null, s), o)), t, l && /* @__PURE__ */ d.createElement(b, { className: u("vd-flex-1 vd-pb-16 vd-px-16", a) }, l)), mo = ({
  titleComponent: e,
  topTagComponent: r,
  bottomTagComponent: t,
  footerComponent: o,
  contentComponent: s,
  containerClass: n = "",
  footerContainerClass: l = "",
  ...a
}) => /* @__PURE__ */ d.createElement(
  b,
  {
    key: a == null ? void 0 : a.key,
    className: u(
      "vd-p-16 vd-flex-col vd-bg-surface-neutral-elevate-low",
      n
    )
  },
  r && /* @__PURE__ */ d.createElement(b, { className: "vd-pb-12" }, r),
  e ? /* @__PURE__ */ d.createElement(b, { className: "vd-pb-12" }, e) : null,
  s && /* @__PURE__ */ d.createElement(b, { className: "vd-flex-col vd-pb-16 vd-gap-y-8" }, s),
  t && /* @__PURE__ */ d.createElement(b, { className: "vd-flex-row" }, t),
  o && /* @__PURE__ */ d.createElement(b, { className: u("vd-flex-1", l) }, o)
), re = {
  theme: "scaler",
  mode: "light"
}, Zr = (e) => {
  e && ["scaler", "interviewbit", "topic", "mba"].includes(e) ? re.theme = e : console.error(`Invalid theme type: ${e}`);
}, Qr = (e) => {
  e && ["dark", "light"].includes(e) ? re.mode = e : console.error(`Invalid mode: ${e}`);
}, Yr = () => {
  const e = `vds ${re.theme}`, r = re.mode;
  return { theme: e, mode: r };
}, po = {
  setTheme: Zr,
  setMode: Qr,
  getThemeConfig: Yr
};
export {
  bo as Accordion,
  io as Banner,
  uo as BottomSheet,
  Zt as Button,
  ro as Checkbox,
  fo as Comfortable,
  go as Compact,
  mo as Compressed,
  C as Icon,
  vo as Input,
  ao as Label,
  lo as ListItem,
  co as Modal,
  Ce as Option,
  Xr as OptionGroup,
  no as Pictogram,
  oo as Radio,
  xo as Select,
  so as Tags,
  I as Text,
  Lr as Timeline,
  b as View,
  u as cx,
  po as vdsConfig
};
